import { AHText } from "arkh";
import React from "react";
import { FileRowWrapper } from "./FileRowWrapper";
import { OrgTableTitle } from "../OrgTable/OrgTable";

export function FileListItemRow(props: {
  icon: React.ReactNode;
  title: string;
  size: string;
  detail: React.ReactNode;
}) {
  return (
    <FileRowWrapper
      icon={props.icon}
      title={<OrgTableTitle>{props.title}</OrgTableTitle>}
      size={
        <AHText
          color="darkText"
          numberOfLines={1}
          style={{ flex: 1 }}
          type="body"
        >
          {props.size}
        </AHText>
      }
      detail={
        <AHText
          color="darkText"
          numberOfLines={1}
          style={{ flex: 1 }}
          type="body"
        >
          {props.detail}
        </AHText>
      }
      action={null}
    />
  );
}
